// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form__Wr4KP {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 24px;
}

.transportContainer__ez06F {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
}

.labourCostsForm__iMXzf {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;
}

.header__jqJqY,
.transportRow__bANbl {
  display: flex;
  background-color: #fcfcfc;
  border-radius: 6px;
  border: 1px solid var(--background-light-blue);
  width: 94%;
  padding: 20px 0;
  justify-content: space-around;
  position: relative;
}

.distanceReturnContainer__bgAHH {
  display: flex;
  gap: 100px;
}

.distanceInput__YfV0z,
.destinationDropdown__LAUv9,
.transportDropdown__QajXO {
  padding-top: 3px;
}

.returnInput__V1t3t {
  font-family: 'Helvetica Neue';
  display: flex;
  gap: 24px;
  margin-top: 4px;
}

.vehicleDestinationDistanceReturnContainer__NbcK4 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.vehicleDestinationContainer__u34Xk {
  display: flex;
  gap: 70px;
}

.addAnotherButton__cDL0W {
  display: flex;
  justify-content: center;
}

.costAndInputContainer__NxNJO {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.costTotalCostContainer__GvjTX {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.titles__o6ZH7 {
  display: flex;
  justify-content: flex-start;
}

.price__JCzGV {
  display: flex;
  justify-content: flex-start;
}

.row__X02AO {
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 10px;
  border: 1px solid var(--background-light-blue);
  border-bottom: none;
  gap: 30px;
  background-color: white;
}

.row2__JhhnI {
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 10px;
  border: 1px solid var(--background-light-blue);
  gap: 30px;
  background-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/logistics-form/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,UAAU;EACV,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,8CAA8C;EAC9C,SAAS;EACT,uBAAuB;AACzB","sourcesContent":[".form {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: center;\n  gap: 24px;\n}\n\n.transportContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 25px;\n}\n\n.labourCostsForm {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-gap: 10px;\n}\n\n.header,\n.transportRow {\n  display: flex;\n  background-color: #fcfcfc;\n  border-radius: 6px;\n  border: 1px solid var(--background-light-blue);\n  width: 94%;\n  padding: 20px 0;\n  justify-content: space-around;\n  position: relative;\n}\n\n.distanceReturnContainer {\n  display: flex;\n  gap: 100px;\n}\n\n.distanceInput,\n.destinationDropdown,\n.transportDropdown {\n  padding-top: 3px;\n}\n\n.returnInput {\n  font-family: 'Helvetica Neue';\n  display: flex;\n  gap: 24px;\n  margin-top: 4px;\n}\n\n.vehicleDestinationDistanceReturnContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.vehicleDestinationContainer {\n  display: flex;\n  gap: 70px;\n}\n\n.addAnotherButton {\n  display: flex;\n  justify-content: center;\n}\n\n.costAndInputContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n}\n\n.costTotalCostContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.titles {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.price {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  padding: 10px;\n  border: 1px solid var(--background-light-blue);\n  border-bottom: none;\n  gap: 30px;\n  background-color: white;\n}\n\n.row2 {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  padding: 10px;\n  border: 1px solid var(--background-light-blue);\n  gap: 30px;\n  background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `form__Wr4KP`,
	"transportContainer": `transportContainer__ez06F`,
	"labourCostsForm": `labourCostsForm__iMXzf`,
	"header": `header__jqJqY`,
	"transportRow": `transportRow__bANbl`,
	"distanceReturnContainer": `distanceReturnContainer__bgAHH`,
	"distanceInput": `distanceInput__YfV0z`,
	"destinationDropdown": `destinationDropdown__LAUv9`,
	"transportDropdown": `transportDropdown__QajXO`,
	"returnInput": `returnInput__V1t3t`,
	"vehicleDestinationDistanceReturnContainer": `vehicleDestinationDistanceReturnContainer__NbcK4`,
	"vehicleDestinationContainer": `vehicleDestinationContainer__u34Xk`,
	"addAnotherButton": `addAnotherButton__cDL0W`,
	"costAndInputContainer": `costAndInputContainer__NxNJO`,
	"costTotalCostContainer": `costTotalCostContainer__GvjTX`,
	"titles": `titles__o6ZH7`,
	"price": `price__JCzGV`,
	"row": `row__X02AO`,
	"row2": `row2__JhhnI`
};
export default ___CSS_LOADER_EXPORT___;
